module.exports = __webpack_public_path__ + "static/step_1-beca402262d8289d3efd0c47b7b7e7e3.png";